export const uk = {
    'banner-types': 'Примеры объявления в блоках Рекламной сети Яндекса',
    'banner-types-description':
        'Внешний вид объявления зависит от настроек каждой площадки. Обратите внимание, в некоторых форматах часть текста объявления может обрезаться.',
    'desktop-and-mobile': 'Десктопные и мобильные площадки',
    'more-about-video': 'Подробнее о видеодополнениях',
    'no-video-text': 'Для этого объявления видеодополнение выключено. Вы можете добавить его в конструкторе.',
    size: 'Размер',
    video: 'Видеоплощадки'
};
